var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boards-app gl-relative",class:{ 'is-compact': _vm.isSidebarOpen }},[_c('board-content',{attrs:{"disabled":_vm.disabled}}),_vm._v(" "),_c('board-settings-sidebar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }